export const data2 = [{
    title:"Email",
    desc:"Email Service provider"
},
{
    title:"Landing Pages",
    desc:"Design Landing Pages of Your Choice"
},
{
    title:"Digital Ads",
    desc:"Create Ads to Engage Consumers"


}
]